import React from "react";
import styled from "styled-components";

const Onion = styled.div`
  text-align: center;
`;

export default props => <Onion {...props}>🧅</Onion>;
